<template>
	<div class="design-1 floor-wsw floors_border floor-bgImg-box" :id="data.block_name+c_index">
		<floorHeader :info="data"></floorHeader>
		<div class="design-1-body-wrap">
			<div class="wrp-img">
				<div v-for="(item,index) in data.value.topImgs" :key="index">
					<el-image :src="$img(item.value.url) " fit='scale-down'  @click="$router.pushToTab(item.value.link.url)" style=" height:300px; width:100%" ></el-image>
				</div>
			</div>
			<div class="wrp-swiper" @click="jumpToLink">
				<vue-seamless-scroll :data="data.value.bannerImgs" :class-option="optionLeft" class="v-swiper">
					<ul class="swiper-ul" :style="{ width: 120 * data.value.bannerImgs.length + 'px' }">
						<template v-for="(item, index) in data.value.bannerImgs" >
							<li>
								<img :data-url="item.value.link.url" :src="$img(item.value.url)" style="width: 120px; height: 100px"/>
							</li>
						</template>
					</ul>
				</vue-seamless-scroll>
			</div>
		</div>
		<floorBgImg :info="data"></floorBgImg>
	</div>
</template>

<script>
import floorHeader from "./floor-header.vue";
import floorBgImg from "./floor-bgImg.vue";
export default {
	name: "floor-style-ermei-design-2",
	components: {
		floorHeader,
        floorBgImg
	},
	props: {
		data: {
			type: Object
		},
		c_index:{
            type: Number
        }
	},
	data() {
		return {}
	},
	mounted() {
		if(this.data.value.bannerImgs.length > 0 && this.data.value.bannerImgs.length < 9){
			let temp = [...this.data.value.bannerImgs];
			this.data.value.bannerImgs.push(...temp);
			this.data.value.bannerImgs.push(...temp);
		}
	},
	computed: {
		optionLeft() {
			return {
				limitMoveNum: 2,
				direction: 3
			}
		}
	},
	methods: {
		jumpToLink(e) {
			if(e.target.dataset.url){
				this.$router.pushToTab(e.target.dataset.url);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.design-1 {
	background-color: #fff;
	margin-top: 20px;
	&-body-wrap {
		position: relative;
		z-index: 2;
		.wrp-img {
			height: 300px;
			display: flex;
			margin-bottom: 10px;
			cursor: pointer;
			&>div {
				height: 300px;
				flex: 1;
				margin-left: 10px;
				border-radius: 15px;
				overflow: hidden;

				.el-image {
					border-radius: 5px;
				}

				&:nth-child(3n + 1) {
					margin-left: 0px;
				}
			}
		}

		.wrp-swiper {
			overflow: hidden;
			.v-swiper {
					width: 135px* 9;
					height: 120px;
					margin: 0 auto;
					overflow: hidden;
				}
			.swiper-ul {
				display: flex;
			
				&>li {
					box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
					cursor: pointer;
				}
			}
		}
	}
}
</style>